<template>
  <div>
    <vue-headful
    title="Dashboard | Edit Billing Information"
    description="Dashboard | Edit Billing Information"
/>

<div v-if="loading" class="loader" style="margin: 100px auto;">
  <br><br>
  <div>
    <ul>
      <li>
        <svg viewBox="0 0 90 120" fill="currentColor">
          <path d="M90,0 L90,120 L11,120 C4.92486775,120 0,115.075132 0,109 L0,11 C0,4.92486775 4.92486775,0 11,0 L90,0 Z M71.5,81 L18.5,81 C17.1192881,81 16,82.1192881 16,83.5 C16,84.8254834 17.0315359,85.9100387 18.3356243,85.9946823 L18.5,86 L71.5,86 C72.8807119,86 74,84.8807119 74,83.5 C74,82.1745166 72.9684641,81.0899613 71.6643757,81.0053177 L71.5,81 Z M71.5,57 L18.5,57 C17.1192881,57 16,58.1192881 16,59.5 C16,60.8254834 17.0315359,61.9100387 18.3356243,61.9946823 L18.5,62 L71.5,62 C72.8807119,62 74,60.8807119 74,59.5 C74,58.1192881 72.8807119,57 71.5,57 Z M71.5,33 L18.5,33 C17.1192881,33 16,34.1192881 16,35.5 C16,36.8254834 17.0315359,37.9100387 18.3356243,37.9946823 L18.5,38 L71.5,38 C72.8807119,38 74,36.8807119 74,35.5 C74,34.1192881 72.8807119,33 71.5,33 Z"></path>
        </svg>
      </li>
      <li>
        <svg viewBox="0 0 90 120" fill="currentColor">
          <path d="M90,0 L90,120 L11,120 C4.92486775,120 0,115.075132 0,109 L0,11 C0,4.92486775 4.92486775,0 11,0 L90,0 Z M71.5,81 L18.5,81 C17.1192881,81 16,82.1192881 16,83.5 C16,84.8254834 17.0315359,85.9100387 18.3356243,85.9946823 L18.5,86 L71.5,86 C72.8807119,86 74,84.8807119 74,83.5 C74,82.1745166 72.9684641,81.0899613 71.6643757,81.0053177 L71.5,81 Z M71.5,57 L18.5,57 C17.1192881,57 16,58.1192881 16,59.5 C16,60.8254834 17.0315359,61.9100387 18.3356243,61.9946823 L18.5,62 L71.5,62 C72.8807119,62 74,60.8807119 74,59.5 C74,58.1192881 72.8807119,57 71.5,57 Z M71.5,33 L18.5,33 C17.1192881,33 16,34.1192881 16,35.5 C16,36.8254834 17.0315359,37.9100387 18.3356243,37.9946823 L18.5,38 L71.5,38 C72.8807119,38 74,36.8807119 74,35.5 C74,34.1192881 72.8807119,33 71.5,33 Z"></path>
        </svg>
      </li>
      <li>
        <svg viewBox="0 0 90 120" fill="currentColor">
          <path d="M90,0 L90,120 L11,120 C4.92486775,120 0,115.075132 0,109 L0,11 C0,4.92486775 4.92486775,0 11,0 L90,0 Z M71.5,81 L18.5,81 C17.1192881,81 16,82.1192881 16,83.5 C16,84.8254834 17.0315359,85.9100387 18.3356243,85.9946823 L18.5,86 L71.5,86 C72.8807119,86 74,84.8807119 74,83.5 C74,82.1745166 72.9684641,81.0899613 71.6643757,81.0053177 L71.5,81 Z M71.5,57 L18.5,57 C17.1192881,57 16,58.1192881 16,59.5 C16,60.8254834 17.0315359,61.9100387 18.3356243,61.9946823 L18.5,62 L71.5,62 C72.8807119,62 74,60.8807119 74,59.5 C74,58.1192881 72.8807119,57 71.5,57 Z M71.5,33 L18.5,33 C17.1192881,33 16,34.1192881 16,35.5 C16,36.8254834 17.0315359,37.9100387 18.3356243,37.9946823 L18.5,38 L71.5,38 C72.8807119,38 74,36.8807119 74,35.5 C74,34.1192881 72.8807119,33 71.5,33 Z"></path>
        </svg>
      </li>
      <li>
        <svg viewBox="0 0 90 120" fill="currentColor">
          <path d="M90,0 L90,120 L11,120 C4.92486775,120 0,115.075132 0,109 L0,11 C0,4.92486775 4.92486775,0 11,0 L90,0 Z M71.5,81 L18.5,81 C17.1192881,81 16,82.1192881 16,83.5 C16,84.8254834 17.0315359,85.9100387 18.3356243,85.9946823 L18.5,86 L71.5,86 C72.8807119,86 74,84.8807119 74,83.5 C74,82.1745166 72.9684641,81.0899613 71.6643757,81.0053177 L71.5,81 Z M71.5,57 L18.5,57 C17.1192881,57 16,58.1192881 16,59.5 C16,60.8254834 17.0315359,61.9100387 18.3356243,61.9946823 L18.5,62 L71.5,62 C72.8807119,62 74,60.8807119 74,59.5 C74,58.1192881 72.8807119,57 71.5,57 Z M71.5,33 L18.5,33 C17.1192881,33 16,34.1192881 16,35.5 C16,36.8254834 17.0315359,37.9100387 18.3356243,37.9946823 L18.5,38 L71.5,38 C72.8807119,38 74,36.8807119 74,35.5 C74,34.1192881 72.8807119,33 71.5,33 Z"></path>
        </svg>
      </li>
      <li>
        <svg viewBox="0 0 90 120" fill="currentColor">
          <path d="M90,0 L90,120 L11,120 C4.92486775,120 0,115.075132 0,109 L0,11 C0,4.92486775 4.92486775,0 11,0 L90,0 Z M71.5,81 L18.5,81 C17.1192881,81 16,82.1192881 16,83.5 C16,84.8254834 17.0315359,85.9100387 18.3356243,85.9946823 L18.5,86 L71.5,86 C72.8807119,86 74,84.8807119 74,83.5 C74,82.1745166 72.9684641,81.0899613 71.6643757,81.0053177 L71.5,81 Z M71.5,57 L18.5,57 C17.1192881,57 16,58.1192881 16,59.5 C16,60.8254834 17.0315359,61.9100387 18.3356243,61.9946823 L18.5,62 L71.5,62 C72.8807119,62 74,60.8807119 74,59.5 C74,58.1192881 72.8807119,57 71.5,57 Z M71.5,33 L18.5,33 C17.1192881,33 16,34.1192881 16,35.5 C16,36.8254834 17.0315359,37.9100387 18.3356243,37.9946823 L18.5,38 L71.5,38 C72.8807119,38 74,36.8807119 74,35.5 C74,34.1192881 72.8807119,33 71.5,33 Z"></path>
        </svg>
      </li>
      <li>
        <svg viewBox="0 0 90 120" fill="currentColor">
          <path d="M90,0 L90,120 L11,120 C4.92486775,120 0,115.075132 0,109 L0,11 C0,4.92486775 4.92486775,0 11,0 L90,0 Z M71.5,81 L18.5,81 C17.1192881,81 16,82.1192881 16,83.5 C16,84.8254834 17.0315359,85.9100387 18.3356243,85.9946823 L18.5,86 L71.5,86 C72.8807119,86 74,84.8807119 74,83.5 C74,82.1745166 72.9684641,81.0899613 71.6643757,81.0053177 L71.5,81 Z M71.5,57 L18.5,57 C17.1192881,57 16,58.1192881 16,59.5 C16,60.8254834 17.0315359,61.9100387 18.3356243,61.9946823 L18.5,62 L71.5,62 C72.8807119,62 74,60.8807119 74,59.5 C74,58.1192881 72.8807119,57 71.5,57 Z M71.5,33 L18.5,33 C17.1192881,33 16,34.1192881 16,35.5 C16,36.8254834 17.0315359,37.9100387 18.3356243,37.9946823 L18.5,38 L71.5,38 C72.8807119,38 74,36.8807119 74,35.5 C74,34.1192881 72.8807119,33 71.5,33 Z"></path>
        </svg>
      </li>
    </ul>
  </div><span>Loading</span>
</div>


    <div v-if="!loading" class="sc-kEYyzF grKTOC">
       <div class="sc-kAdXeD jwoEpG" style="padding: 75px 20px 0px 20px!important;">
          <div class="sc-bvTASY jPMoWD">
             <div class="sc-cFlXAS WflZx">
                <div style="position: relative;">

                <div>
                  <br><br>
                    <h1 style="text-align: center;">Edit Billing Information</h1>
                    <br>
                       <div class="card border-light shadow-soft mb-5" style="max-width: 800px;margin: 0 auto;width: 70%;padding: 10px;">
                          <div class="card-body p-4 p-lg-3">
                                  <div class="row" style="display: flex; flex-wrap: wrap; margin-right: -15px; margin-left: -15px;">
                                      <div class="col-12">
                                          <div class="form-group">
                                              <label class="form-label text-dark">Client Name <span class="text-danger">*</span></label>
                                              <div class="input-group mb-4">
                                                  <div class="input-group-prepend">
                                                      <span class="input-group-text"><i class="fas fa-user-alt"></i></span>
                                                  </div>
                                                  <input v-model="clientname" name="clientname" class="form-control" placeholder="eg. John Doe" type="text">
                                              </div>
                                              <span v-if="clientname === '' && required" class="small" style="color: rgb(237, 80, 79); visibility: visible; position: relative;bottom: 15px;">This field is required.</span>
                                          </div>
                                      </div>
                                      <div class="col-12">
                                          <div class="form-group">
                                              <label class="form-label text-dark">Street Address <span class="text-danger">*</span></label>
                                              <div class="input-group mb-4">
                                                  <div class="input-group-prepend">
                                                      <span class="input-group-text"><i class="fas fa-map-marker-alt"></i></span>
                                                  </div>
                                                  <input v-model="streetaddress" name="address" class="form-control" placeholder="eg. One Infinite Loop" type="address">
                                              </div>
                                              <span v-if="streetaddress === '' && required" class="small" style="color: rgb(237, 80, 79); visibility: visible; position: relative;bottom: 15px;">This field is required.</span>
                                          </div>
                                      </div>
                                      <div class="col-12">
                                          <div class="form-group">
                                              <label class="form-label text-dark">City, State, Country <span class="text-danger">*</span></label>
                                              <div class="input-group mb-4">
                                                  <div class="input-group-prepend">
                                                      <span class="input-group-text"><i class="fas fa-map-marker-alt"></i></span>
                                                  </div>
                                                  <input v-model="location" name="location" class="form-control" placeholder="eg. Cupertino, CA, United States" type="text">
                                              </div>
                                              <span v-if="location === '' && required" class="small" style="color: rgb(237, 80, 79); visibility: visible; position: relative;bottom: 15px;">This field is required.</span>
                                          </div>
                                      </div>
                                      <div class="col-12">
                                          <div class="form-group">
                                              <label class="form-label text-dark">Zip Code <span class="text-danger">*</span></label>
                                              <div class="input-group mb-4">
                                                  <div class="input-group-prepend">
                                                      <span class="input-group-text"><i class="fas fa-map-pin"></i></span>
                                                  </div>
                                                  <input v-model="zipcode" name="zip" class="form-control" placeholder="eg. 95014" type="text">
                                              </div>
                                              <span v-if="zipcode === '' && required" class="small" style="color: rgb(237, 80, 79); visibility: visible; position: relative;bottom: 15px;">This field is required.</span>
                                          </div>
                                      </div>
                                      <div class="col-12">
                                          <div class="form-group">
                                              <label class="form-label text-dark">Phone Number <span class="text-gray">*</span></label>
                                              <div class="input-group mb-4">
                                                  <div class="input-group-prepend">
                                                      <span class="input-group-text"><i class="fas fa-phone"></i></span>
                                                  </div>
                                                  <input v-model="phonenumber" name="phonenumber" class="form-control" placeholder="eg. +1 111 1111111" type="tel">
                                              </div>
                                          </div>
                                      </div>
                                      <div class="text-center" style="margin: 0 auto;">
                                            <button v-if="!loading_edit" @click="guardarbilling" class="btn btn-primary mt-4 animate-up-2"><span class="mr-2"><i class="fas fa-paper-plane"></i></span>Save Billing Information</button>
                                            <button v-if="loading_edit" class="btn btn-primary mt-4 animate-up-2"><span class="mr-2"><i class="fas fa-spinner"></i></span>Loading...</button>
                                        </div>
                                  </div>
                          </div>
                      </div>
                  </div>

             </div>
          </div>
       </div>
    </div>

  </div>

</template>

<style>
a {
  color: #515151;
}
@media (max-width:991px) {
  .card{
    width:100%!important;
  }
}
.card-body {
    flex: 1 1 auto;
    padding: 1.5rem;
}
/* .row {
    display: flex;
    flex-wrap: wrap;
    margin-right: -15px;
    margin-left: -15px;
} */
.col-12 {
    flex: 0 0 100%;
    max-width: 100%;
}
.form-group {
    position: relative;
}
.form-group {
    margin-bottom: 1rem;
}
.text-dark, .text-dark:hover {
    color: #0d1431 !important;
}
.form-label {
    font-weight: 400;
    font-size: 1rem;
    display: block;
}
.text-danger, .text-danger:hover {
    color: #FA5252 !important;
}
.input-group {
    border-radius: 0.5rem;
    transition: all 0.2s ease;
}
.mb-4, .my-4 {
    margin-bottom: 1.5rem !important;
}
.input-group {
    position: relative;
    display: flex;
    flex-wrap: wrap;
    align-items: stretch;
    width: 100%;
}
.input-group-prepend {
    margin-right: -2px;
}
.input-group-text {
    font-size: 0.875rem;
    transition: all 0.3s ease-in-out;
}
.fa, .fas {
    font-weight: 900;
}
.fa, .far, .fas {
    font-family: "Font Awesome 5 Free";
}
.input-group .form-control:not(:first-child) {
    border-left: 0;
    padding-left: 0;
}
.input-group > .form-control, .input-group > .form-control-plaintext, .input-group > .custom-select, .input-group > .custom-file {
    position: relative;
    flex: 1 1 auto;
    width: 1%;
    margin-bottom: 0;
}
.input-group .form-control:not(:first-child) {
    border-left: 0;
    padding-left: 0;
}
.text-center {
    text-align: center !important;
}
.animate-up-2, .animate-right-2, .animate-down-2, .animate-left-2, .scale-up-2, .scale-down-2 {
    transition: all 0.2s ease;
}
button:not(:disabled), [type="button"]:not(:disabled), [type="reset"]:not(:disabled), [type="submit"]:not(:disabled) {
    cursor: pointer;
}
.mr-2, .mx-2 {
    margin-right: 0.5rem !important;
}
</style>

  <script>
  export default {
    data() {
      return {
        loading: true,
        loading_edit: false,
        clientname: '',
        streetaddress: '',
        location: '',
        zipcode: '',
        phonenumber: '',
        required: false
      };
    },
    methods: {
      guardarbilling(){
        this.loading_edit = true;
        axios.post('/dashboard/edit-billing.php', {
          clientname: this.clientname,
          streetaddress: this.streetaddress,
          location: this.location,
          zipcode: this.zipcode,
          phonenumber: this.phonenumber
          })
          .then(response => {
            if(response.data == 'required'){
              this.required = true;
            }
            else{
              this.required = false;
              this.$router.push('/dashboard/billing');
            }
            this.loading_edit = false;
        })
          .catch(function (error) {
            console.log(error);
          });
      }
    },
    mounted() {
      this.$emit('updateprops');
      //BILLING
      axios.post('/dashboard/cargar-billing.php', {
        })
        .then(response => {
          this.clientname = response.data[0].clientname;
          this.streetaddress = response.data[0].streetaddress;
          this.location = response.data[0].location;
          this.zipcode = response.data[0].zipcode;
          this.phonenumber = response.data[0].phonenumber;
          this.loading = false;
      })
        .catch(function (error) {
          console.log(error);
        });
    }
  };
  </script>



// WEBPACK FOOTER //
// src/edit-billing.vue